import AltRouteIcon from "@mui/icons-material/AltRoute";
import BlockIcon from "@mui/icons-material/Block";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PanToolIcon from "@mui/icons-material/PanTool";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import page5_section2 from "../../../assets/images/AboutVedaz/page5_section2.jpg";
import page9_section1 from "../../../assets/images/AboutVedaz/page9_section1.jpg";
import page9_section3 from "../../../assets/images/AboutVedaz/page9_section3.jpg";
import page9_section5 from "../../../assets/images/AboutVedaz/page9_section5.jpg";
import classes from "../AboutVedaz.styles";
import { ColorBanner, FeaturePoint } from "./CompatComponents";

interface Props {
  chapterIndex: number;
}

const SoulPathAspect = ({ chapterIndex }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      {/* ── Section 1: Background image ───────────────────────────── */}
      <Box sx={classes.bgSection}>
        <Box
          component="img"
          src={page9_section1}
          alt=""
          sx={classes.bgSectionMedia}
        />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_soulPath_heading")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_soulPath_s1_body1")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px", mb: 0 }}>
            {t("about_soulPath_s1_body2")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 2: Red — plain section with feature points ────── */}
      <Box sx={classes.plainSection}>
        <ColorBanner
          colorKey="red"
          Icon={BlockIcon}
          header={t("about_soulPath_red_header")}
          subtitle={t("about_soulPath_red_subtitle")}
        />
        <FeaturePoint
          colorKey="red"
          Icon={AltRouteIcon}
          title={t("about_soulPath_red_p1_title")}
          body={t("about_soulPath_red_p1_body")}
        />
        <FeaturePoint
          colorKey="red"
          Icon={PanToolIcon}
          title={t("about_soulPath_red_p2_title")}
          body={t("about_soulPath_red_p2_body")}
        />
        <FeaturePoint
          colorKey="red"
          Icon={SearchOffIcon}
          title={t("about_soulPath_red_p3_title")}
          body={t("about_soulPath_red_p3_body")}
        />
      </Box>

      {/* ── Section 3: Dark Green — background image ─────────────── */}
      <Box sx={classes.bgSection}>
        <Box
          component="img"
          src={page9_section3}
          alt=""
          sx={classes.bgSectionMedia}
        />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <ColorBanner
            colorKey="darkGreen"
            Icon={FavoriteIcon}
            header={t("about_soulPath_darkGreen_header")}
            subtitle={t("about_soulPath_darkGreen_subtitle")}
          />
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_soulPath_darkGreen_body1")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_soulPath_darkGreen_body2")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px", mb: 0 }}>
            {t("about_soulPath_darkGreen_body3")}
          </Typography>
        </Box>
      </Box>

      {/* ── Section 4: Risk Groups — content left, image right ────── */}
      <Box sx={classes.sideRow}>
        <Box sx={classes.sideContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_soulPath_riskGroup_header")}
          </Typography>
          <Typography
            sx={{
              ...classes.bodyText,
              fontWeight: 600,
              color: "rgba(255,255,255,0.9)",
              mb: 2,
            }}
          >
            {t("about_soulPath_riskGroup_subheader")}
          </Typography>
          <Typography sx={classes.bodyText}>
            {t("about_soulPath_riskGroup_body1")}
          </Typography>
          <Typography sx={classes.bodyText}>
            {t("about_soulPath_riskGroup_body2")}
          </Typography>
          <Typography sx={classes.bodyText}>
            {t("about_soulPath_riskGroup_body3")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, mb: 0 }}>
            {t("about_soulPath_riskGroup_body4")}
          </Typography>
        </Box>
        <Box sx={classes.sideImage}>
          <img
            src={page5_section2}
            alt={t("about_soulPath_riskGroup_header")}
          />
        </Box>
      </Box>

      {/* ── Section 5: Harmonious — image left, content right ─────── */}
      <Box sx={classes.bgSection}>
        <Box
          component="img"
          src={page9_section5}
          alt=""
          sx={classes.bgSectionMedia}
        />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_soulPath_harmonious_header")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_soulPath_harmonious_body1")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px" }}>
            {t("about_soulPath_harmonious_body2")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px", mb: 0 }}>
            {t("about_soulPath_harmonious_body3")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "420px", mb: 0 }}>
            {t("about_soulPath_harmonious_body4")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SoulPathAspect;
